import { Component, Inject } from '@angular/core';
import { InputComponent } from '../../../../../shared/components/input/input.component';
import { ModalComponent } from '../../../../../shared/components/modal/modal.component';
import { TegelModule } from '@scania/tegel-angular-17';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RecebimentoService } from '../../../../../shared/services/recebimento.service';
import { ToastService } from '../../../../../shared/services/toast.service';
import { ToastState as ts } from '../../../../../shared/enums/toast-state.enum';

import { FilaFiscal } from '../../../models/fila-fiscal';
import { DateHelper } from '../../../../../shared/helpers/date.helper';
import { FaseId } from '../../../../../shared/enums/fase.enum';

@Component({
  selector: 'app-sla-dialog-fiscal',
  imports: [
    ButtonComponent,
    InputComponent,
    ModalComponent,
    TegelModule,
    ReactiveFormsModule,
  ],
  templateUrl: './sla-dialog-fiscal.component.html',
  styleUrl: './sla-dialog-fiscal.component.scss',
})
export class SlaDialogFiscalComponent {
  public fase = FaseId;

  form: FormGroup;
  filaId: number;
  recebimentoId: number;

  constructor(
    private dialogRef: MatDialogRef<SlaDialogFiscalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private fb: FormBuilder,
    private workflowService: RecebimentoService,
    private toast: ToastService,
  ) {
    this.filaId = data.id;
    this.recebimentoId = data.recebimentoId;

    const formattedDataEntrada = DateHelper.utcToLocalString(
      data.dataEntrada,
      'dd/MM/yyyy HH:mm:ss',
    );

    this.form = this.fb.group({
      senha: [data.recebimento.senha ?? ''],
      dataEntrada: formattedDataEntrada,
      registro: [data?.recebimento?.registro ?? ''],
      critico: [data?.recebimento.critico ?? false],
      milkrun: [data?.recebimento.milkrun ?? false],
      controlCenter: [data?.recebimento?.controlCenter ?? false],
    });
  }

  processar(proximaFaseId: number) {
    if (this.form.invalid) {
      this.toast.showToast(ts.error, 'Formulário inválido.');
      return;
    }

    const formValues = this.form.value;

    const dto: FilaFiscal = {
      filaId: this.filaId,
      recebimentoId: this.recebimentoId,
      proximaFaseId: proximaFaseId,
      registro: formValues.registro,
      critico: formValues.critico,
      milkrun: formValues.milkrun,
      controlCenter: formValues.controlCenter,
    };

    this.workflowService.processamentoFiscal(dto).subscribe({
      next: (result) => {
        this.toast.showToast(ts.success, 'Processado com sucesso!');
        this.dialogRef.close(result.content);
      },
      error: (e) => this.toast.showToast(ts.error, e.error[0]),
    });
  }

  onClose() {
    this.dialogRef.close();
  }
}
